PES=PES|| {}
PES.OtlScreenshotsAnimation=function(){
    var init= function() {
        $(".map_link").on("click",
            function(e) {
                e.preventDefault();
                $(".map_link").removeClass("active");
                $(this).addClass("active");
                var containerID = $(this).attr("class").split(" ")[0];
                $(".map_image").removeClass("active");
                $("#" + containerID).addClass("active");
            });
    }
    return{
        init:init
    }
}